// 바이어가 운영팀에 보내는 추가 요청들 — 브랜드/마크업 정보/상품.
export const buyerRequestsUrl = {
  addBrand: (buyerId: number) => `/buyers/${buyerId}/requests/add-brand`,
  addMarkupInfo: (buyerId: number) =>
    `/buyers/${buyerId}/requests/add-markup-info`,
  addProduct: (buyerId: number) => `/buyers/${buyerId}/requests/add-product`,
};
